import { MeganIFrame } from "components/organisms/MeganIFrame";

const Megan = () => {
  return <MeganIFrame page="megan" />;
};

export { Megan };
